import React from "react";
import { Button } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Modal from "~/shared/ui/Fields/Modal";
import { formatDisplayValue } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/display";
import { TEmployeeProfileUser } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/types";

import { DataRow, DataRows } from "./DataRows";

import s from "./UserProfileModals.less";

const USER_PROFILE_FIELDS: Array<{
  key: keyof TEmployeeProfileUser;
  labelKey: string;
}> = [
  { key: "id", labelKey: "employee.id" },
  { key: "login", labelKey: "employee.login" },
  { key: "fullname", labelKey: "employee.fullname" },
  { key: "phone", labelKey: "employee.phone" },
  { key: "email", labelKey: "employee.email" },
  { key: "roleRu", labelKey: "employee.role" },
];

interface IUserProfileModalProps {
  isOpen: boolean;
  titleKey?: string;
  user?: TEmployeeProfileUser | null;
  onClose: () => void;
  withDivider?: boolean;
}

const UserProfileModal = ({
  isOpen,
  titleKey,
  user,
  onClose,
  withDivider,
}: IUserProfileModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      actionClose={onClose}
      w={600}
      withCloseBtn={false}
      withoutMargin
      customClassName={s.userProfileModal}
    >
      {titleKey && (
        <div className={s.content}>
          <p className={s.title}>{t(titleKey)}</p>

          <DataRows>
            {USER_PROFILE_FIELDS.map((field) => (
              <DataRow key={field.key} compact label={`${t(field.labelKey)}:`}>
                {formatDisplayValue(
                  user?.[field.key] as string | number | null | undefined,
                )}
              </DataRow>
            ))}
          </DataRows>

          <div className={s.footer}>
            {withDivider && <div className={s.divider} />}
            <div className={s.buttons}>
              <Button
                bold
                color="secondary"
                fontSize="14"
                size="medium"
                radius={5}
                onClick={onClose}
              >
                {t("ui.close")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UserProfileModal;
